import GMaps from 'gmaps';

const Yco = Yco || {};

function initContactMap() {
	const mapElement = document.querySelector('#yco-map');

	if (!mapElement) {
		return;
	}

	const styles = [
		{
			"featureType": "landscape",
			"stylers": [{"saturation": -100}, {"lightness": 60}]
		}, {
			"featureType": "road.local",
			"stylers": [{"saturation": -100}, {"lightness": 40}, {"visibility": "on"}]
		}, {
			"featureType": "transit",
			"stylers": [{"saturation": -100}, {"visibility": "simplified"}]
		}, {"featureType": "administrative.province", "stylers": [{"visibility": "off"}]}, {
			"featureType": "water",
			"stylers": [{"visibility": "on"}, {"lightness": 30}]
		}, {
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [{"color": "#ef8c25"}, {"lightness": 40}]
		}, {
			"featureType": "road.highway",
			"elementType": "geometry.stroke",
			"stylers": [{"visibility": "off"}]
		}, {
			"featureType": "poi.park",
			"elementType": "geometry.fill",
			"stylers": [{"color": "#b6c54c"}, {"lightness": 40}, {"saturation": -40}]
		}, {
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#EBEBEB"
				}
			]
		}, {
			"featureType": "water",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#9e9e9e"
				}
			]
		},
		// {
		// 	"featureType": "poi.attraction",
		// 	"elementType": "labels.icon",
		// 	"stylers": [
		// 		{
		// 			"saturation": -100
		// 		}
		// 	]
		// },
		{
			"featureType": "poi.attraction",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.attraction",
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"weight": 1
				}
			]
		},
		// {
		// 	"featureType": "poi.business",
		// 	"elementType": "labels.icon",
		// 	"stylers": [
		// 		{
		// 			"saturation": -100
		// 		}
		// 	]
		// },
		{
			"featureType": "poi.business",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.business",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.government",
			"elementType": "labels.icon",
			"stylers": [
				{
					"saturation": -100
				}
			]
		},
		{
			"featureType": "poi.government",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.medical",
			"elementType": "labels.icon",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.medical",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "labels.icon",
			"stylers": [
				{
					"saturation": -100
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.place_of_worship",
			"elementType": "labels.icon",
			"stylers": [
				{
					"saturation": -100
				}
			]
		},
		{
			"featureType": "poi.place_of_worship",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.school",
			"elementType": "labels.icon",
			"stylers": [
				{
					"saturation": -100
				}
			]
		},
		{
			"featureType": "poi.school",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		},
		{
			"featureType": "poi.sports_complex",
			"elementType": "labels.icon",
			"stylers": [
				{
					"saturation": -100
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "labels.icon",
			"stylers": [
				{
					"color": "#6cbc78"
				}
			]
		},
		{
			"featureType": "poi.sports_complex",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#c0c0c0"
				}
			]
		}, {}
	];

	Yco.maps = Yco.maps || {};
	const mapCenter = { lat: 46.2731898, lng: 18.3569742 }; // Set them to handle map position

	Yco.maps.contactMap = new GMaps({
		disableDefaultUI: false,
		el: mapElement,
		lat: mapCenter.lat,
		lng: mapCenter.lng,
		scrollwheel: false,
		streetViewControl: false,
		zoom: 16,
	});
	Yco.maps.bounds = new google.maps.LatLngBounds();

	function offsetCenter(latlng) {

		// latlng is the apparent centre-point
		// offsetx is the distance you want that point to move to the right, in pixels
		// offsety is the distance you want that point to move upwards, in pixels
		// offset can be negative
		// offsetx and offsety are both optional

		const offsetx = $('#yco-map').width() * -0.25,
			offsety = $('#yco-map').height() * 0.05,
			scale = Math.pow(2, Yco.maps.contactMap.getZoom()),
			worldCoordinateCenter = Yco.maps.contactMap.getProjection().fromLatLngToPoint(latlng),
			pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);

		const worldCoordinateNewCenter = new google.maps.Point(
			worldCoordinateCenter.x - pixelOffset.x,
			worldCoordinateCenter.y + pixelOffset.y
		);

		return Yco.maps.contactMap.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
	}
	// Disabled, because admin set address overwrite GMaps init positions
	// $.each($('[data-address]'), function (index, item) {
	// 	const $this = $(this);

	// 	GMaps.geocode({
	// 		address: $this.data('address'),
	// 		callback: (results, status) => {
	// 			console.log(results);
	// 			if (!results.length) {
	// 				return;
	// 			}

	// 			const latlng = results[0].geometry.location;

	// 			Yco.maps.bounds.extend(
	// 				new google.maps.LatLng(
	// 					latlng.lat(),
	// 					latlng.lng()
	// 				)
	// 			);

	// 			Yco.maps.contactMap.addMarker({
	// 				lat: latlng.lat(),
	// 				lng: latlng.lng(),
	// 				icon: `${window.Yco.themeURL}/assets/icons/pin_green.svg`
	// 			});

	// 			// Yco.maps.contactMap.map.setCenter(Yco.maps.bounds.getCenter());
	// 			Yco.maps.contactMap.map.setCenter(offsetCenter(Yco.maps.bounds.getCenter()));
	// 		}
	// 	});
	// });

	Yco.maps.contactMap.addMarker({
		lat: mapCenter.lat,
		lng: mapCenter.lng,
		icon: `${window.Yco.themeURL}/assets/icons/pin_green.svg`,
	});
	Yco.maps.contactMap.map.setCenter(offsetCenter(new google.maps.LatLng(mapCenter.lat, mapCenter.lng)));


	Yco.maps.contactMap.addStyle({
		styledMapName: 'Contact page map',
		styles,
		mapTypeId: 'contact_page_map_style',
	});

	Yco.maps.contactMap.setStyle('contact_page_map_style');
}

$(() => {
	initContactMap();
});



// WEBPACK FOOTER //
// ./assets/scripts/maps.js